import styled from 'styled-components';
import { Typ30 } from '../Typ';

type WrapperProps = {
  $selected?: boolean;
  $highlight?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  background-color: ${props => (props.$selected ? '#004750' : '#007079')};
  padding: 5px 12px;
  margin: 0 8px 8px 0;
  border-radius: 14px;
  display: inline;
  white-space: nowrap;
  cursor: pointer;
  &:hover {
    background-color: #004750;
  }
  box-shadow: ${props =>
    props.$highlight ? '0 0 0 99999px rgba(0,0,0,0.5)' : 'none'};
  z-index: ${props => (props.$highlight ? 2 : 0)};
`;

export const Tag = styled(Typ30)`
  color: #fff;
`;
